import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useResourceLiveStreamNotAttachedQuery = createQueryHook(
  MembershipsCreatorV2ApiClient.getResourceLiveStreamNotAttached,
  {
    queryKey: ['resourceLiveStreamNotAttached'],
  },
)
